fx.ns("desktop.common.toolbar", class ToolBarSelectFont extends desktop.common.toolbar.ToolBarSelect{
    
    constructor(command, component, container)
    {
        super(command, component, container); 
    }

    onReady()
    {
        super.onReady();
        this.verticalList.top(this.realHeight);
    }

    render()
    {
        let current = this.command.items.find({id : this.component[this.command.field] }); 
        
        return "<div class='label'>" + this._renderThumb(current) + "</div>";
        
    }

    onSelected(e)
    {
        this._updateThumb( e.detail );

        this.action( e.detail );
        
    }

    selectionChanged()
    {
        let id = this.component[this.command.field];

        this.verticalList.selected = id;

        // selection-changed fires on every keystroke : skip the catalogue scan and the label rebuild while the font is unchanged.
        if (id == this._thumbId)
            return;

        this._updateThumb( this.command.items.find({id : id}) );
    }

    // The catalogue holds UI fonts with no thumb, and the id may no longer resolve : emit no <img> rather than src="undefined".
    _renderThumb(font)
    {
        return (font && font.thumb) ? "<img class='image' src='" + font.thumb + "'>" : "";
    }

    _updateThumb(font)
    {
        this._thumbId = font ? font.id : null;

        let label = this.find(".label");
        if (label)
            label.innerHTML = this._renderThumb(font);
    }

});